import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../firebase';
import { checkoutVerify } from '../api';
import { capture } from '../tracking/posthog';

export default function KaufErfolg() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('laden'); // laden | erfolg | fehler

  useEffect(() => {
    const sessionId = params.get('session_id');
    if (!sessionId) {
      navigate('/profileinstellungen', { replace: true });
      return;
    }

    let cancelled = false;

    const run = async () => {
      // Warte bis Firebase auth.currentUser verfügbar ist (max 10 s)
      let waited = 0;
      while (!auth.currentUser && waited < 10000) {
        await new Promise(r => setTimeout(r, 200));
        waited += 200;
      }
      if (cancelled) return;
      if (!auth.currentUser) {
        navigate('/', { replace: true });
        return;
      }
      try {
        const res = await checkoutVerify(sessionId);
        if (cancelled) return;
        capture('purchase_completed', {
          plan: res.data?.subscription?.price_id,
          product: res.data?.subscription?.product_name,
          platform: 'web',
        });
        setStatus('erfolg');
        setTimeout(() => navigate('/profileinstellungen', { replace: true }), 2000);
      } catch {
        if (cancelled) return;
        setStatus('fehler');
        setTimeout(() => navigate('/profileinstellungen', { replace: true }), 3000);
      }
    };

    run();
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--cv-bg-base, #F5F2E9)',
      gap: 16,
      fontFamily: 'Inter, sans-serif',
    }}>
      {status === 'laden' && (
        <>
          <div style={{ width: 48, height: 48, border: '3px solid var(--cv-teal, #004D40)', borderTopColor: 'transparent', borderRadius: '50%', animation: 'kauf-spin 0.8s linear infinite' }} />
          <p style={{ color: 'var(--cv-teal, #004D40)', fontWeight: 600, fontSize: 18 }}>Abo wird aktiviert…</p>
        </>
      )}
      {status === 'erfolg' && (
        <>
          <div style={{ width: 56, height: 56, background: 'var(--cv-teal, #004D40)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <p style={{ color: 'var(--cv-teal, #004D40)', fontWeight: 700, fontSize: 20 }}>Abo aktiviert!</p>
          <p style={{ color: '#666', fontSize: 14 }}>Du wirst weitergeleitet…</p>
        </>
      )}
      {status === 'fehler' && (
        <>
          <p style={{ color: 'var(--cv-teal, #004D40)', fontWeight: 600, fontSize: 18 }}>Weiterleitung…</p>
          <p style={{ color: '#666', fontSize: 13 }}>Falls das Abo nicht sofort erscheint, kurz auf Aktualisieren klicken.</p>
        </>
      )}
      <style>{`@keyframes kauf-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
